import { Component, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { AppState } from '../../config/state';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import { LoginProvider } from '../../providers/login/login';
/**
 * Generated class for the CoSelfcheckHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-selfcheck-header',
  templateUrl: 'co-selfcheck-header.html'
})
export class CoSelfcheckHeaderComponent {
	@Input() cssRules: any = {};
	@Input() standalone: boolean = false;
	@Output() logoutClicked = new EventEmitter<any>();
	@Output() myAccountClicked = new EventEmitter<any>();

  constructor(private state: AppState, private el:ElementRef, private loginProvider:LoginProvider) {
  }
  myaccount($event){
	if(this.standalone){
		this.state.nav.push(CoSelfcheckAccountPage);
	}else{
	  this.myAccountClicked.emit($event);
	}
  }
  logout($event){
	  if(this.standalone){
		this.loginProvider.logout().then( done =>{
			if( done ){
				this.state.nav.popToRoot();
			}
		})
	  }else{
	  	this.logoutClicked.emit($event);
	  }
  }
  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
//        this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-selfcheck-header/co-selfcheck-header.ts